import { render, staticRenderFns } from "./UserTransaction.vue?vue&type=template&id=21ed6238&scoped=true&"
import script from "./UserTransaction.vue?vue&type=script&lang=js&"
export * from "./UserTransaction.vue?vue&type=script&lang=js&"
import style0 from "./UserTransaction.vue?vue&type=style&index=0&id=21ed6238&prod&lang=scss&"
import style1 from "./UserTransaction.vue?vue&type=style&index=1&id=21ed6238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed6238",
  null
  
)

export default component.exports